var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoGraySolid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C3.85812 15.5 0.5 12.1419 0.5 8C0.5 3.85812 3.85812 0.5 8 0.5C12.1419 0.5 15.5 3.85812 15.5 8C15.5 12.1419 12.1419 15.5 8 15.5ZM8 12.375C8.41561 12.375 8.7499 12.0332 8.74067 11.6177L8.64655 7.38234C8.63874 7.03086 8.35157 6.75 8 6.75C7.64843 6.75 7.36126 7.03086 7.35345 7.38234L7.25933 11.6177C7.2501 12.0332 7.58439 12.375 8 12.375ZM8.00188 3.50688C7.48438 3.50688 7.175 3.7825 7.175 4.24562C7.175 4.7175 7.48375 4.99312 8.00188 4.99312C8.51563 4.99312 8.82438 4.7175 8.82438 4.24562C8.82438 3.7825 8.51563 3.50688 8.00188 3.50688Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGraySolid);
export default __webpack_public_path__ + "static/media/info-gray-solid.9419d52f2a34740a675574951a2d62e5.svg";
export { ForwardRef as ReactComponent };